<template>
  <div class="main-container">
    <app-header rootClassName="header-root-class-name2"></app-header>
    <div class="main-hero">
      <h1 class="main-text">
        &quot;Formamos personas en busca de la excelencia&quot;
      </h1>
      <div class="main-btn-group"></div>
    </div>
    <div class="main-features">
      <h1 class="main-text01">
        <span>Ultimas Noticias</span>
        <br />
      </h1>
      <span class="main-text04">
        SE LE INFORMA A LA COMUNIDAD EN GENERAL QUE SE ENCUENTRA ABIERTA LA LICITACIÓN PARA ARRENDAMIENTO DE LOS ESPACIOS DESTINADOS AL FUNCIONAMIENTO DE LA TIENDA ESCOLAR (CAFETERIA) DE LA SEDE PRINCIPAL, DE LA SECCIÓN PRIMARIA Y SECUNDARIA DE LA INSTITUCIÓN EDUCATIVA JORGE GUILLERMO MOJICA MARQUEZ. 
        <a href="/#/normativa" class="normativa-link" style="color: #007bff; text-decoration: underline; font-weight: bold;">Ver documentos de contratación aquí</a>
      </span>
      <div class="main-container1">
        <div v-if="loading" class="loading-message">
          <p>Cargando últimos documentos...</p>
        </div>
        <template v-else>
          <app-noticias
            v-for="(doc, index) in documentosRecientes"
            :key="index"
            :title="doc.title"
            :description="doc.description"
            :action="doc.action"
            :image_src="doc.image_src"
            :rootClassName="`rootClassName${index}`"
            @click="abrirDocumento(doc.url)"
            style="cursor: pointer;"
          ></app-noticias>
        </template>
      </div>
    </div>
    <div class="main-stats">
      <div class="main-stat">
        <svg viewBox="0 0 1152 1024" class="main-icon">
          <path
            d="M768 770.612v-52.78c70.498-39.728 128-138.772 128-237.832 0-159.058 0-288-192-288s-192 128.942-192 288c0 99.060 57.502 198.104 128 237.832v52.78c-217.102 17.748-384 124.42-384 253.388h896c0-128.968-166.898-235.64-384-253.388z"
          ></path>
          <path
            d="M327.196 795.328c55.31-36.15 124.080-63.636 199.788-80.414-15.054-17.784-28.708-37.622-40.492-59.020-30.414-55.234-46.492-116.058-46.492-175.894 0-86.042 0-167.31 30.6-233.762 29.706-64.504 83.128-104.496 159.222-119.488-16.914-76.48-61.94-126.75-181.822-126.75-192 0-192 128.942-192 288 0 99.060 57.502 198.104 128 237.832v52.78c-217.102 17.748-384 124.42-384 253.388h279.006c14.518-12.91 30.596-25.172 48.19-36.672z"
          ></path>
        </svg>
        <span class="main-text05">Estudiantes</span>
        <h1 class="main-text06">+500</h1>
      </div>
      <div class="main-stat1">
        <svg viewBox="0 0 1152 1024" class="main-icon03">
          <path
            d="M768 770.612v-52.78c70.498-39.728 128-138.772 128-237.832 0-159.058 0-288-192-288s-192 128.942-192 288c0 99.060 57.502 198.104 128 237.832v52.78c-217.102 17.748-384 124.42-384 253.388h896c0-128.968-166.898-235.64-384-253.388z"
          ></path>
          <path
            d="M327.196 795.328c55.31-36.15 124.080-63.636 199.788-80.414-15.054-17.784-28.708-37.622-40.492-59.020-30.414-55.234-46.492-116.058-46.492-175.894 0-86.042 0-167.31 30.6-233.762 29.706-64.504 83.128-104.496 159.222-119.488-16.914-76.48-61.94-126.75-181.822-126.75-192 0-192 128.942-192 288 0 99.060 57.502 198.104 128 237.832v52.78c-217.102 17.748-384 124.42-384 253.388h279.006c14.518-12.91 30.596-25.172 48.19-36.672z"
          ></path>
        </svg>
        <span class="main-text07">Egresados</span>
        <h1 class="main-text08">+3000</h1>
      </div>
      <div class="main-stat2">
        <svg viewBox="0 0 1024 1024" class="main-icon06">
          <path
            d="M810 640v-86h-84v86h84zM810 810v-84h-84v84h84zM554 298v-84h-84v84h84zM554 470v-86h-84v86h84zM554 640v-86h-84v86h84zM554 810v-84h-84v84h84zM298 470v-86h-84v86h84zM298 640v-86h-84v86h84zM298 810v-84h-84v84h84zM640 470h256v426h-768v-598h256v-84l128-128 128 128v256z"
          ></path>
        </svg>
        <span class="main-text09">Sedes</span>
        <h1 class="main-text10">10</h1>
      </div>
      <div class="main-stat3">
        <svg viewBox="0 0 1152 1024" class="main-icon08">
          <path
            d="M768 770.612v-52.78c70.498-39.728 128-138.772 128-237.832 0-159.058 0-288-192-288s-192 128.942-192 288c0 99.060 57.502 198.104 128 237.832v52.78c-217.102 17.748-384 124.42-384 253.388h896c0-128.968-166.898-235.64-384-253.388z"
          ></path>
          <path
            d="M327.196 795.328c55.31-36.15 124.080-63.636 199.788-80.414-15.054-17.784-28.708-37.622-40.492-59.020-30.414-55.234-46.492-116.058-46.492-175.894 0-86.042 0-167.31 30.6-233.762 29.706-64.504 83.128-104.496 159.222-119.488-16.914-76.48-61.94-126.75-181.822-126.75-192 0-192 128.942-192 288 0 99.060 57.502 198.104 128 237.832v52.78c-217.102 17.748-384 124.42-384 253.388h279.006c14.518-12.91 30.596-25.172 48.19-36.672z"
          ></path>
        </svg>
        <span class="main-text11">Funcionarios</span>
        <h1 class="main-text12">+50</h1>
      </div>
    </div>
    <div class="main-features1">
      <h1 class="main-text13">Descubre Nuestras Modalidades</h1>
      <div class="main-container2">
        <img alt="image" src="/descubre-1400w.png" class="main-image" />
        <div class="main-container3">
          <app-modalidad
            title="Patronaje Industrial de Prendas de Vestir"
            image_src="/adobestock_585062461.svg"
            description="Únete a nosotros para aprender más sobre esta emocionante disciplina que da forma a la moda"
            rootClassName="rootClassName1"
          ></app-modalidad>
          <app-modalidad
            title="Mecánico de Maquinaria Industrial"
            image_src="/copia%20de%20adobestock_585062461.svg"
            description="Descubre los secretos detrás del funcionamiento de las máquinas que impulsan la industria"
            rootClassName="rootClassName4"
          ></app-modalidad>
          <app-modalidad
            title="Contabilización de Operaciones Comerciales y Financieras"
            image_src="/adobestock_541220524.svg"
            description="Explora y profundiza en el fascinante mundo de la contabilidad empresarial."
            rootClassName="rootClassName3"
          ></app-modalidad>
        </div>
        <img alt="image" src="/descubre-1400w.png" class="main-image1" />
      </div>
    </div>
    <div class="main-testimonial">
      <div class="main-container4">
        <h1 class="main-text14">
          <span>Lo que están diciendo </span>
          <br />
        </h1>
        <div class="main-container5">
          <div class="main-testimonial1">
            <div class="main-testimonial2">
              <div class="main-container6">
                <svg viewBox="0 0 950.8571428571428 1024" class="main-icon11">
                  <path
                    d="M438.857 548.571v219.429c0 60.571-49.143 109.714-109.714 109.714h-219.429c-60.571 0-109.714-49.143-109.714-109.714v-402.286c0-161.143 131.429-292.571 292.571-292.571h36.571c20 0 36.571 16.571 36.571 36.571v73.143c0 20-16.571 36.571-36.571 36.571h-36.571c-80.571 0-146.286 65.714-146.286 146.286v18.286c0 30.286 24.571 54.857 54.857 54.857h128c60.571 0 109.714 49.143 109.714 109.714zM950.857 548.571v219.429c0 60.571-49.143 109.714-109.714 109.714h-219.429c-60.571 0-109.714-49.143-109.714-109.714v-402.286c0-161.143 131.429-292.571 292.571-292.571h36.571c20 0 36.571 16.571 36.571 36.571v73.143c0 20-16.571 36.571-36.571 36.571h-36.571c-80.571 0-146.286 65.714-146.286 146.286v18.286c0 30.286 24.571 54.857 54.857 54.857h128c60.571 0 109.714 49.143 109.714 109.714z"
                  ></path>
                </svg>
              </div>
              <span class="main-text17">
                La Institución garantiza a la comunidad educativa la articulación
                de la educación media con la educación superior, para el trabajo y
                el desarrollo humano buscando que los jóvenes fortalezcan sus
                competencias básicas, ciudadanas y desarrollen las competencias
                especificas necesarias para continuar su formación a lo largo de
                toda la vida e insertarse competitivamente en el mundo del trabajo
                o iniciar un programa de educación superior.
              </span>
              <div class="main-container7">
                <svg viewBox="0 0 950.8571428571428 1024" class="main-icon13">
                  <path
                    d="M438.857 182.857v402.286c0 161.143-131.429 292.571-292.571 292.571h-36.571c-20 0-36.571-16.571-36.571-36.571v-73.143c0-20 16.571-36.571 36.571-36.571h36.571c80.571 0 146.286-65.714 146.286-146.286v-18.286c0-30.286-24.571-54.857-54.857-54.857h-128c-60.571 0-109.714-49.143-109.714-109.714v-219.429c0-60.571 49.143-109.714 109.714-109.714h219.429c60.571 0 109.714 49.143 109.714 109.714zM950.857 182.857v402.286c0 161.143-131.429 292.571-292.571 292.571h-36.571c-20 0-36.571-16.571-36.571-36.571v-73.143c0-20 16.571-36.571 36.571-36.571h36.571c80.571 0 146.286-65.714 146.286-146.286v-18.286c0-30.286-24.571-54.857-54.857-54.857h-128c-60.571 0-109.714-49.143-109.714-109.714v-219.429c0-60.571 49.143-109.714 109.714-109.714h219.429c60.571 0 109.714 49.143 109.714 109.714z"
                  ></path>
                </svg>
              </div>
            </div>
            <span class="main-text18">Docentes</span>
            <span class="main-text19">Area Técnica</span>
          </div>
        </div>
      </div>
    </div>
    <div class="main-features2">
      <h1 class="main-text20">Descubre</h1>
      <div class="main-container8">
        <router-link to="/nosotros">
          <app-descubre
            title="Manual de Convivencia"
            image_src="/manual.svg"
            rootClassName="rootClassName"
            class="main-component07"
          ></app-descubre>
        </router-link>
        <app-descubre
          title="Calendario"
          image_src="/calendario.svg"
          rootClassName="rootClassName1"
        ></app-descubre>
        <app-descubre
          title="Galeria"
          image_src="/galeria.svg"
          rootClassName="rootClassName2"
        ></app-descubre>
        <router-link to="/secciones">
          <app-descubre
            title="Sedes"
            image_src="/sedes.svg"
            rootClassName="rootClassName3"
            class="main-component10"
          ></app-descubre>
        </router-link>
        <router-link to="/modalidades">
          <app-descubre
            title="Areas Técnicas"
            image_src="/modalidad.svg"
            rootClassName="rootClassName7"
            class="main-component11"
          ></app-descubre>
        </router-link>
        <router-link to="/docentes">
          <app-descubre
            title="Docentes"
            image_src="/docentes.svg"
            rootClassName="rootClassName6"
            class="main-component12"
          ></app-descubre>
        </router-link>
        <app-descubre
          title="Normativa"
          image_src="/normassvg.svg"
          rootClassName="rootClassName5"
        ></app-descubre>
        <app-descubre
          title="Correo Institucional"
          image_src="/correo.svg"
          rootClassName="rootClassName4"
        ></app-descubre>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import AppHeader from '../components/header'
import AppNoticias from '../components/noticias'
import AppModalidad from '../components/modalidad'
import AppDescubre from '../components/descubre'
import AppFooter from '../components/footer'
import api from '../services/api'

export default {
  name: 'Main',
  components: {
    AppHeader,
    AppNoticias,
    AppModalidad,
    AppDescubre,
    AppFooter,
  },
  setup() {
    const documentosRecientes = ref([])
    const loading = ref(false)

    const getDocumentIcon = (mimeType, nombreArchivo) => {
      // Determinar icono según tipo de archivo
      if (mimeType?.includes('pdf') || nombreArchivo?.toLowerCase().endsWith('.pdf')) {
        return 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"%3E%3Cpath fill="%23dc3545" d="M181.9 256.1c-5-16-4.9-46.9-2-46.9 8.4 0 7.6 36.9 2 46.9zm-1.7 47.2c-7.7 20.2-17.3 43.3-28.4 62.7 18.3-7 39-17.2 62.9-21.9-12.7-9.6-24.9-23.4-34.5-40.8zM86.1 428.1c0 .8 13.2-5.4 34.9-40.2-6.7 6.3-29.1 24.5-34.9 40.2zM248 160h136v328c0 13.3-10.7 24-24 24H24c-13.3 0-24-10.7-24-24V24C0 10.7 10.7 0 24 0h200v136c0 13.2 10.8 24 24 24zm-8 171.8c-20-12.2-33.3-29-42.7-53.8 4.5-18.5 11.6-46.6 6.2-64.2-4.7-29.4-42.4-26.5-47.8-6.8-5 18.3-.4 44.1 8.1 77-11.6 27.6-28.7 64.6-40.8 85.8-.1 0-.1.1-.2.1-27.1 13.9-73.6 44.5-54.5 68 5.6 6.9 16 10 21.5 10 17.9 0 35.7-18 61.1-61.8 25.8-8.5 54.1-19.1 79-23.2 21.7 11.8 47.1 19.5 64 19.5 29.2 0 31.2-32 19.7-43.4-13.9-13.6-54.3-9.7-73.6-7.2zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9zm-74.1 255.3c4.1-2.7-2.5-11.9-42.8-9 37.1 15.8 42.8 9 42.8 9z"/%3E%3C/svg%3E'
      } else if (mimeType?.includes('word') || nombreArchivo?.toLowerCase().match(/\.(doc|docx)$/)) {
        return 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"%3E%3Cpath fill="%232b579a" d="M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm57.1 120H305c7.7 0 13.4 7.1 11.7 14.7l-38 168c-1.2 5.5-6.1 9.3-11.7 9.3h-38c-5.5 0-10.3-3.8-11.6-9.1-25.8-103.5-20.8-81.2-25.6-110.5h-.5c-1.1 14.3-2.4 17.4-25.6 110.5-1.3 5.3-6.1 9.1-11.6 9.1H116c-5.6 0-10.5-3.9-11.7-9.4l-37.8-168c-1.7-7.5 4-14.6 11.7-14.6h24.5c5.7 0 10.7 4 11.8 9.7 15.6 78 20.1 109.5 21 122.2 1.6-10.2 7.3-32.7 29.4-122.7 1.3-5.4 6.1-9.1 11.7-9.1h29.1c5.6 0 10.4 3.8 11.7 9.2 24 100.4 28.8 124 29.6 129.4-.2-11.2-2.6-17.8 21.6-129.2 1-5.6 5.9-9.5 11.5-9.5zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"/%3E%3C/svg%3E'
      } else if (mimeType?.includes('excel') || mimeType?.includes('spreadsheet') || nombreArchivo?.toLowerCase().match(/\.(xls|xlsx)$/)) {
        return 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"%3E%3Cpath fill="%23217346" d="M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm60.1 106.5L224 336l60.1 93.5c5.1 8-.6 18.5-10.1 18.5h-34.9c-4.4 0-8.5-2.4-10.6-6.3C208.9 405.5 192 373 192 373c-6.4 14.8-10 20-36.6 68.8-2.1 3.9-6.1 6.3-10.5 6.3H110c-9.5 0-15.2-10.5-10.1-18.5l60.3-93.5-60.3-93.5c-5.2-8 .6-18.5 10.1-18.5h34.8c4.4 0 8.5 2.4 10.6 6.3 26.1 48.8 20 33.6 36.6 68.5 0 0 6.1-11.7 36.6-68.5 2.1-3.9 6.2-6.3 10.6-6.3H274c9.5-.1 15.2 10.4 10.1 18.4zM384 121.9v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"/%3E%3C/svg%3E'
      } else if (mimeType?.includes('image') || nombreArchivo?.toLowerCase().match(/\.(jpg|jpeg|png|gif|webp)$/)) {
        return 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"%3E%3Cpath fill="%2328a745" d="M464 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM112 120c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56zM64 384h384V272l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 320l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 336v48z"/%3E%3C/svg%3E'
      } else {
        return 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"%3E%3Cpath fill="%236c757d" d="M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm76.45 211.36l-96.42 95.7c-6.65 6.61-17.39 6.61-24.04 0l-96.42-95.7C73.42 337.29 80.54 320 94.82 320H160v-80c0-8.84 7.16-16 16-16h32c8.84 0 16 7.16 16 16v80h65.18c14.28 0 21.4 17.29 11.27 27.36zM377 105L279 7c-4.5-4.5-10.6-7-17-7h-6v128h128v-6.1c0-6.3-2.5-12.4-7-16.9z"/%3E%3C/svg%3E'
      }
    }

    const cargarDocumentosRecientes = async () => {
      loading.value = true
      try {
        const response = await api.getRecentDocuments(3)
        if (response.success) {
          documentosRecientes.value = response.data.map(doc => ({
            title: doc.tipoDocumentoNombre,
            description: doc.nombreArchivo,
            action: 'Ver documento',
            url: api.getDocumentDownloadUrl(doc.id),
            image_src: getDocumentIcon(doc.mimeType, doc.nombreArchivo),
            fecha: new Date(doc.fechaCarga).toLocaleDateString('es-ES', {
              year: 'numeric',
              month: 'long',
              day: 'numeric'
            })
          }))
        }
      } catch (error) {
        console.error('Error cargando documentos recientes:', error)
        // Si hay error, mostrar noticias por defecto
        documentosRecientes.value = [
          { title: 'Noticia 1', description: 'Este es un resumen del evento', action: 'Ver más' },
          { title: 'Comunicado', description: 'Información para Padres de Familia' },
          { title: 'Circulares', description: 'Información general a la comunidad' }
        ]
      } finally {
        loading.value = false
      }
    }

    const abrirDocumento = (url) => {
      if (url) {
        window.open(url, '_blank')
      }
    }

    onMounted(() => {
      cargarDocumentosRecientes()
    })

    return {
      documentosRecientes,
      loading,
      abrirDocumento
    }
  },
  metaInfo: {
    title: 'ColegioTasco',
    meta: [
      {
        property: 'og:title',
        content: 'ColegioTasco',
      },
    ],
  },
}
</script>

<style scoped>
.main-container {
  width: 100%;
  display: flex;
  overflow: auto;
  min-height: 100vh;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
}
.main-hero {
  width: 100%;
  display: flex;
  padding: var(--dl-space-space-threeunits);
  position: relative;
  max-width: 100%;
  min-height: 80vh;
  align-items: center;
  flex-direction: column;
  background-size: cover;
  justify-content: center;
  background-image: url("/cole-1500h.jpg");
  background-position: center;
}
.main-text {
  color: var(--dl-color-gray-white);
  width: 60%;
  font-size: 3rem;
  text-align: center;
}
.main-btn-group {
  border: 2px dashed rgba(120, 120, 120, 0.4);
  display: flex;
  align-items: center;
  flex-direction: row;
}
.main-features {
  width: 100%;
  display: flex;
  padding: var(--dl-space-space-threeunits);
  max-width: var(--dl-size-size-maxwidth);
  align-items: center;
  flex-direction: column;
}
.main-text01 {
  font-size: 3rem;
  margin-bottom: var(--dl-space-space-twounits);
}
.main-text04 {
  color: var(--dl-color-gray-700);
  width: 70%;
  font-size: 1.15rem;
  text-align: center;
}
.main-container1 {
  flex: 1;
  width: 100%;
  display: grid;
  grid-gap: var(--dl-space-space-twounits);
  align-self: center;
  margin-top: var(--dl-space-space-fourunits);
  grid-template-columns: 1fr 1fr 1fr;
}
.loading-message {
  grid-column: 1 / -1;
  text-align: center;
  padding: var(--dl-space-space-twounits);
  color: var(--dl-color-gray-700);
  font-size: 1.15rem;
}
.main-stats {
  width: 100%;
  display: flex;
  padding: var(--dl-space-space-threeunits);
  max-width: 100%;
  justify-content: center;
  background-color: var(--dl-color-main-primary);
}
.main-stat {
  display: flex;
  padding: var(--dl-space-space-twounits);
  align-items: center;
  padding-top: 32px;
  flex-direction: column;
}
.main-icon {
  fill: var(--dl-color-text-white);
  width: var(--dl-size-size-small);
  height: var(--dl-size-size-small);
}
.main-text05 {
  color: var(--dl-color-text-white);
  font-size: 2rem;
  margin-top: var(--dl-space-space-halfunit);
  text-align: center;
}
.main-text06 {
  color: var(--dl-color-text-white);
  font-size: 3rem;
  margin-top: var(--dl-space-space-halfunit);
  font-weight: 300;
}
.main-stat1 {
  display: flex;
  padding: var(--dl-space-space-twounits);
  align-items: center;
  padding-top: 32px;
  flex-direction: column;
}
.main-icon03 {
  fill: var(--dl-color-text-white);
  width: var(--dl-size-size-small);
  height: var(--dl-size-size-small);
}
.main-text07 {
  color: var(--dl-color-text-white);
  font-size: 2rem;
  margin-top: var(--dl-space-space-halfunit);
  text-align: center;
}
.main-text08 {
  color: var(--dl-color-text-white);
  font-size: 3rem;
  margin-top: var(--dl-space-space-halfunit);
  font-weight: 300;
}
.main-stat2 {
  display: flex;
  padding: var(--dl-space-space-twounits);
  align-items: center;
  padding-top: 32px;
  flex-direction: column;
}
.main-icon06 {
  fill: var(--dl-color-text-white);
  width: var(--dl-size-size-small);
  height: var(--dl-size-size-small);
}
.main-text09 {
  color: var(--dl-color-text-white);
  font-size: 2rem;
  margin-top: var(--dl-space-space-halfunit);
  text-align: center;
}
.main-text10 {
  color: var(--dl-color-text-white);
  font-size: 3rem;
  margin-top: var(--dl-space-space-halfunit);
  font-weight: 300;
}
.main-stat3 {
  display: flex;
  padding: var(--dl-space-space-twounits);
  align-items: center;
  padding-top: 32px;
  flex-direction: column;
}
.main-icon08 {
  fill: var(--dl-color-text-white);
  width: var(--dl-size-size-small);
  height: var(--dl-size-size-small);
}
.main-text11 {
  color: var(--dl-color-text-white);
  font-size: 2rem;
  margin-top: var(--dl-space-space-halfunit);
  text-align: center;
}
.main-text12 {
  color: var(--dl-color-text-white);
  font-size: 3rem;
  margin-top: var(--dl-space-space-halfunit);
  font-weight: 300;
}
.main-features1 {
  width: 100%;
  display: flex;
  padding: var(--dl-space-space-threeunits);
  max-width: var(--dl-size-size-default);
  flex-direction: column;
}
.main-text13 {
  font-size: 3rem;
  margin-bottom: var(--dl-space-space-twounits);
}
.main-container2 {
  flex: 0 0 auto;
  width: 100%;
  display: flex;
  margin-top: var(--dl-space-space-twounits);
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
}
.main-image {
  width: 450px;
  height: 450px;
  display: none;
  object-fit: contain;
  flex-shrink: 0;
  margin-left: var(--dl-space-space-fourunits);
  border-radius: var(--dl-radius-radius-round);
  object-position: center;
}
.main-container3 {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.main-image1 {
  width: 450px;
  height: 450px;
  object-fit: contain;
  flex-shrink: 0;
  margin-left: 0px;
  border-radius: var(--dl-radius-radius-round);
  object-position: center;
}
.main-testimonial {
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: #485158;
}
.main-container4 {
  width: 100%;
  display: flex;
  padding: var(--dl-space-space-threeunits);
  max-width: var(--dl-size-size-maxwidth);
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.main-text14 {
  color: var(--dl-color-gray-white);
  font-size: 3em;
}
.main-container5 {
  flex: 0 0 auto;
  width: auto;
  height: auto;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}
.main-testimonial1 {
  width: 100%;
  display: flex;
  padding: var(--dl-space-space-threeunits);
  max-width: var(--dl-size-size-maxwidth);
  align-items: center;
  flex-direction: column;
  justify-content: space-between;
}
.main-testimonial2 {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
}
.main-container6 {
  display: flex;
  align-self: flex-start;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
}
.main-icon11 {
  fill: var(--dl-color-text-white);
  width: var(--dl-size-size-small);
  margin-bottom: -6rem;
}
.main-text17 {
  color: var(--dl-color-text-white);
  font-size: 1.15rem;
  max-width: 90%;
  margin-top: var(--dl-space-space-threeunits);
  text-align: center;
  padding-left: var(--dl-space-space-twounits);
  margin-bottom: var(--dl-space-space-threeunits);
  padding-right: var(--dl-space-space-twounits);
}
.main-container7 {
  display: flex;
  align-self: flex-end;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
}
.main-icon13 {
  fill: var(--dl-color-text-white);
  width: var(--dl-size-size-small);
  margin-top: -6rem;
}
.main-text18 {
  color: var(--dl-color-text-white);
  font-size: 1.5rem;
  max-width: 600px;
  text-align: center;
  font-weight: 600;
  margin-bottom: var(--dl-space-space-halfunit);
}
.main-text19 {
  color: var(--dl-color-text-white);
  max-width: 600px;
  font-style: normal;
  text-align: center;
  font-weight: 500;
}
.main-features2 {
  width: 100%;
  display: flex;
  padding: var(--dl-space-space-threeunits);
  max-width: var(--dl-size-size-maxwidth);
  flex-direction: column;
}
.main-text20 {
  font-size: 3rem;
  margin-bottom: var(--dl-space-space-threeunits);
}
.main-container8 {
  flex: 0 0 auto;
  width: 100%;
  display: grid;
  grid-gap: var(--dl-space-space-twounits);
  align-items: flex-start;
  grid-template-columns: 1fr 1fr 1fr 1fr;
}
.main-component07 {
  text-decoration: none;
}
.main-component10 {
  text-decoration: none;
}
.main-component11 {
  text-decoration: none;
}
.main-component12 {
  text-decoration: none;
}
@media(max-width: 1440px) {
  .main-text17 {
    max-width: 90%;
  }
}
@media(max-width: 1366px) {
  .main-text14 {
    color: var(--dl-color-gray-white);
  }
  .main-text17 {
    color: var(--dl-color-text-white);
    font-size: 1.5rem;
    max-width: 90%;
  }
}
@media(max-width: 991px) {
  .main-hero {
    flex-direction: column;
  }
  .main-text {
    text-align: center;
  }
  .main-text01 {
    text-align: center;
  }
  .main-text04 {
    text-align: center;
  }
  .main-container1 {
    grid-template-columns: 1fr 1fr;
  }
  .main-features1 {
    align-items: center;
  }
  .main-container2 {
    flex-direction: column;
  }
  .main-image {
    width: 100%;
    height: auto;
    display: flex;
    margin-top: var(--dl-space-space-twounits);
    margin-left: 0px;
    border-radius: 0px;
    margin-bottom: var(--dl-space-space-twounits);
  }
  .main-image1 {
    width: 100%;
    height: auto;
    display: none;
    margin-top: var(--dl-space-space-twounits);
    margin-left: 0px;
    border-radius: 0px;
    margin-bottom: var(--dl-space-space-twounits);
  }
  .main-text14 {
    text-align: center;
  }
  .main-text17 {
    margin-top: var(--dl-space-space-threeunits);
    margin-bottom: var(--dl-space-space-threeunits);
  }
  .main-text20 {
    align-self: center;
  }
  .main-container8 {
    grid-template-columns: 1fr 1fr;
  }
}
@media(max-width: 767px) {
  .main-hero {
    padding-left: var(--dl-space-space-twounits);
    padding-right: var(--dl-space-space-twounits);
  }
  .main-features {
    padding-left: var(--dl-space-space-twounits);
    padding-right: var(--dl-space-space-twounits);
  }
  .main-text01 {
    text-align: center;
  }
  .main-stats {
    padding-left: var(--dl-space-space-twounits);
    padding-right: var(--dl-space-space-twounits);
  }
  .main-stat {
    padding: var(--dl-space-space-unit);
  }
  .main-text05 {
    text-align: center;
  }
  .main-stat1 {
    padding: var(--dl-space-space-unit);
  }
  .main-text07 {
    text-align: center;
  }
  .main-stat2 {
    padding: var(--dl-space-space-unit);
  }
  .main-text09 {
    text-align: center;
  }
  .main-stat3 {
    padding: var(--dl-space-space-unit);
  }
  .main-text11 {
    text-align: center;
  }
  .main-features1 {
    padding-left: var(--dl-space-space-twounits);
    padding-right: var(--dl-space-space-twounits);
  }
  .main-text13 {
    text-align: center;
  }
  .main-container2 {
    flex-direction: column;
  }
  .main-container4 {
    padding-left: var(--dl-space-space-twounits);
    padding-right: var(--dl-space-space-twounits);
  }
  .main-testimonial1 {
    padding-left: var(--dl-space-space-twounits);
    padding-right: var(--dl-space-space-twounits);
  }
  .main-features2 {
    padding-left: var(--dl-space-space-twounits);
    padding-right: var(--dl-space-space-twounits);
  }
}
@media(max-width: 720px) {
  .main-image {
    width: 100%;
    height: auto;
    margin-bottom: var(--dl-space-space-twounits);
  }
  .main-container3 {
    grid-template-columns: 1fr;
  }
  .main-image1 {
    width: 100%;
    height: auto;
    margin-bottom: var(--dl-space-space-twounits);
  }
}
@media(max-width: 479px) {
  .main-hero {
    width: 100%;
    padding: var(--dl-space-space-twounits);
    padding-top: var(--dl-space-space-twounits);
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
  }
  .main-btn-group {
    flex-direction: column;
  }
  .main-features {
    padding-top: var(--dl-space-space-twounits);
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
    padding-bottom: var(--dl-space-space-twounits);
  }
  .main-container1 {
    grid-template-columns: 1fr;
  }
  .main-stats {
    align-items: center;
    padding-top: var(--dl-space-space-twounits);
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
    flex-direction: column;
    padding-bottom: var(--dl-space-space-twounits);
  }
  .main-features1 {
    padding-top: var(--dl-space-space-twounits);
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
    padding-bottom: var(--dl-space-space-twounits);
  }
  .main-image {
    width: 250px;
    height: 250px;
  }
  .main-container3 {
    grid-template-columns: 1fr;
  }
  .main-image1 {
    width: 250px;
    height: 250px;
  }
  .main-container4 {
    padding-top: var(--dl-space-space-twounits);
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
    padding-bottom: var(--dl-space-space-twounits);
  }
  .main-testimonial1 {
    padding-top: var(--dl-space-space-twounits);
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
    padding-bottom: var(--dl-space-space-twounits);
  }
  .main-icon11 {
    margin-bottom: 0px;
  }
  .main-text17 {
    width: auto;
  }
  .main-icon13 {
    margin-bottom: var(--dl-space-space-unit);
  }
  .main-features2 {
    padding-top: var(--dl-space-space-twounits);
    padding-left: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-unit);
    padding-bottom: var(--dl-space-space-twounits);
  }
  .main-container8 {
    grid-gap: var(--dl-space-space-halfunit);
  }
}
@media(max-width: 393px) {
  .main-container8{
    grid-template-columns: 1fr;
  }
  .main-stats {
    flex-direction: column;
  }
  .main-container2 {
    margin-top: 0px;
  }
  .main-image {
    width: 100%;
    height: auto;
    border-radius: 0px;
    margin-bottom: var(--dl-space-space-twounits);
  }
  .main-image1 {
    width: 100%;
    height: auto;
    border-radius: 0px;
    margin-bottom: var(--dl-space-space-twounits);
  }
  .main-container4 {
    padding-left: var(--dl-space-space-halfunit);
    padding-right: var(--dl-space-space-halfunit);
  }
  .main-testimonial1 {
    padding: 0px;
  }
  .main-text17 {
    width: 100%;
    font-size: 1.2rem;
    margin-top: var(--dl-space-space-unit);
    text-align: center;
    padding-left: var(--dl-space-space-halfunit);
    margin-bottom: var(--dl-space-space-unit);
    padding-right: var(--dl-space-space-halfunit);
  }
}
</style>
